import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'
import { Icon } from '../../atoms'

const ICON_SIZE = 50

export const CategoryItemSkeleton: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.container}>
      <Skeleton width={ICON_SIZE} height={ICON_SIZE} borderRadius={ICON_SIZE / 2} />
      <View style={styles.info}>
        <Skeleton width="60%" height={16} borderRadius={4} style={styles.nameSkeleton} />
        <Skeleton width="40%" height={14} borderRadius={4} />
      </View>
      <Icon name="arrow" size={24} color={theme.colors.grey20} />
    </View>
  )
}

export const CategoryItemSkeletonList: React.FC<{ count?: number }> = ({ count = 8 }) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View>
      {Array.from({ length: count }).map((_, index) => (
        <View key={index}>
          <CategoryItemSkeleton />
          {index < count - 1 && <View style={styles.separator} />}
        </View>
      ))}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
    },
    info: {
      flex: 1,
      marginLeft: theme.spacing.lg,
    },
    nameSkeleton: {
      marginBottom: theme.spacing.xs,
    },
    separator: {
      height: 0.5,
      backgroundColor: theme.colors.grey,
      marginLeft: theme.spacing.lg,
    },
  })

